module.exports = __webpack_public_path__ + "img/Logo_Models.531cdb9e.svg";